<template>
    <div class="relatedProduct mb-5"  ref="recommendContainer" v-if="ids">
        <div class="spinner-border text-primary" role="status" v-if="isLoading">
            <span class="sr-only">Loading...</span>
        </div>
        <div class="relatedTitleBox" v-if="!isLoading">
            <h4 class="relatedTitle">相關產品</h4>
            <a href="product" class="more" title="">更多產品</a>
        </div>
        <div class="productCarousel">
            <div class="owl-carousel" v-if="!isLoading" ref="carousel">
                <div class="box" v-for="item in recommends" :key="item.id">
                    <product-component
                        :name="item.name"
                        :product-id="item.id"
                        :slug="item.slug"
                        :pic-url="item.Pics[0]?.url['w0h0']"
                        :min-price="item.minPrice"
                        :favorite-added="item.favoriteAdded ? true : false"
                        :sku="item.productNumber"
                        :category="item.textClassMetas"
                        :preorder-active="item.ProductField?.preorderActive ? true : false"
                        :preorder-to-date="item.ProductField.preorderToDate"
                        :preorder-from-date="item.ProductField.preorderFromDate"
                        :type-id-spec-id-key="item.typeIdSpecIdKey"
                        :rating="item.ratingsAvgRating"
                        :rating-count="item.ratingsCount"
                    ></product-component>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ProductComponent from 'Vue/Web/Shop/Product/ProductComponent.vue';

export default {
    name: 'RecommendProductComponent',
    components: {
        ProductComponent,
    },
    props: {
        ids: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '',
        },
    },
    data() {
        return {
            isLoading: true,
            recommends: [],
            url: '/api/recommendProduct',
        };
    },
    mounted() {
        this.setupIntersectionObserver();
    },
    computed: {},
    methods: {
        setupIntersectionObserver() {
            const options = {
                root: null, // 代表 viewport
                threshold: 0.2, // 當元素進入到 20% 的範圍時觸發
            };

            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && this.ids) {
                        this.getResult();
                        observer.unobserve(this.$refs.recommendContainer); // 只觸發一次，然後停止觀察
                    }
                });
            }, options);

            if (this.$refs.recommendContainer) {
                observer.observe(this.$refs.recommendContainer);
            }
        },
        initOwlCarousel() {
            $(this.$refs.carousel)
                .owlCarousel({
                    autoplay: false,
                    loop: false,
                    center: false,
                    navText: [],
                    nav: false,
                    dot: true,
                    margin: 10,
                    responsive: {
                        0: {
                            items: 1,
                        },
                        480: {
                            items: 2,
                        },
                        768: {
                            items: 3,
                        },
                        1366: {
                            items: 4,
                            margin: 20,
                        },
                    },
                });
        },
        formatDate(dateString) {
            const options = {
                month: 'short',
                day: '2-digit',
                year: 'numeric',
            };
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', options);
        },
        async getResult() {
            let response;
            try {
                response = await axios.get(`${this.url}/${this.ids}`);
                this.recommends = response.data.data;
                this.isLoading = false;

                // 等待 DOM 完全更新後再初始化 OwlCarousel
                this.$nextTick(() => {
                    this.initOwlCarousel();
                });
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>
<style scoped lang="scss">
$maincolor: #72ca4a;
$smallstandard:#555;
$bigstandard: #333;
$character: #666;
$bgcolor: #eee;
.spinner-border {
    margin: 0 50%;
}
.relatedProduct {
    width: 100%;
    .productCarousel {
        margin: 0 -15px;
        width: 100%;
        @media (max-width: 1367px) {
            margin: 0 -7.5px;
        }
        .box {
            padding: 0 15px;
            padding: 0;
            @media (max-width: 1367px) {
                padding: 0 7.5px;
            }
        }
    }
    .relatedTitle {
        color: #333;
        font-size: 18px;
    }

    .relatedTitleBox {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 2rem;
        .more {
            color: $smallstandard;
            position: relative;
            font-size: 12px;
            transition: 0.4s;
            padding: 0;
            &::after {
                content: '';
                position: absolute;
                width: 50%;
                height: 1px;
                bottom: 0px;
                background-color: #999;
                left: 0;
                transition: 0.3s linear;
            }
            &:hover {
                transition: 0.4s;
                color: $maincolor;
                &::after {
                    width: 100%;
                    background: $maincolor;
                    transition: 0.3s linear;
                }
            }
        }
    }
}
</style>
